import ReactSignatureCanvas from 'react-signature-canvas';

import { base64ToBlob } from '@/utils/base64ImageToBlob';

import { uploadFiles } from '@/api';
import { CloudFileDto } from '@/generated-types';

export const uploadSignature = async (signRef: ReactSignatureCanvas): Promise<CloudFileDto> => {
	const signBlob = base64ToBlob(signRef?.getTrimmedCanvas().toDataURL('image/png') ?? '');
	const name = signRef?.getCanvas().toDataURL('image/png') ?? '';

	const signFileName = `${name.toString().slice(-20)} signature.png`;

	const signFile = new File([signBlob], signFileName, { type: 'image/png' });
	const formData = new FormData();
	formData.append('files', signFile);

	const uploadedSign = await uploadFiles(formData);
	return uploadedSign ? uploadedSign[0] : uploadedSign;
};
